<div fxFlex="100" fxLayout="row wrap" [formGroup]="form">
    <div fxLayout="column" class="mb-12" [ngClass]="controlMaxWidth == '150px' && 'm-8 mb-0'"
     [ngStyle]="{'width': controlMaxWidth ? controlMaxWidth : '100%' }">
        <mat-label class="font-weight-400" *ngIf="!outlineLabels">{{fromKeyLabel | translate}}
        </mat-label>
        <mat-form-field appearance="outline" floatLabel="always" color="accent"
          [ngStyle]="{'width': controlMaxWidth ? controlMaxWidth : '100%' }">
            <mat-label class="font-weight-400" *ngIf="outlineLabels">{{fromKeyLabel | translate}}
            </mat-label>
            <input matInput [formControlName]="fromControlName" placeholder="{{'PLACEHOLDER.FROM' | translate}}"
                [matDatepicker]="picker1" [max]="maxDate" [readonly]="readonly" (keydown)="handleKeyDown($event)">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
    </div>

    <div fxLayout="column" class="mb-12" [ngClass]="controlMaxWidth == '150px' && 'm-8 mb-0'"
     [ngStyle]="{'width': controlMaxWidth ? controlMaxWidth : '100%' }">
        <mat-label class="font-weight-400" *ngIf="!outlineLabels">{{toKeyLabel | translate}}
        </mat-label>
        <mat-form-field appearance="outline" floatLabel="always" color="accent"
          [ngStyle]="{'width': controlMaxWidth ? controlMaxWidth : '100%' }">
            <mat-label class="font-weight-400" *ngIf="outlineLabels">{{toKeyLabel | translate}}
            </mat-label>
            <input matInput [formControlName]="toControlName" [min]="minDate" placeholder="{{'PLACEHOLDER.TO' | translate}}"
                [matDatepicker]="picker2"  [readonly]="readonly" (keydown)="handleKeyDown($event)">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
    </div>
</div>